/** @format */

import {
  useEffect,
  useState,
} from 'react';

import axios from 'axios';
import Cookies from 'js-cookie';
import { useParams } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

//components
import { useMessageContext } from '../../../context/Message.context';
import useAddUserForNewseletter
  from '../../../utils/apis/AddUserForNewseLetter';
import GetTemplateData from '../../../utils/apis/GetTemplateData.api';
import { HelmetSEO } from '../../../utils/HelmetSEO/HelmetSEO.utilcomponent';
import ExclusiveListingTemp1
  from '../../Template1/ExclusiveListing/Exclusivelisting.component';
import ImageRedirectContainer
  from '../../Template2/components/ImageRedirector/imageredirectort3.component';
import { SubscribeContainer3 } from '../../Template2/home/home.style';
import FeaturePropertySlider
  from '../../utilComponent/FeaturePropertySlider/FeaturePropertySlider.utilComponent';
import BlogSlider from '../Components/blog_slider/blog_slider.component';
import CitiesCard from '../Components/cities/citiescard.component';
import FindProperty from '../Components/FindProperty/FindProperty.component';
import HeroSection from '../Components/HeroSectionHome/HeroSection.component';
import { Listing1 } from '../Components/Listing1/Listing1.t3';
import ListingBuilderDeals
  from '../Components/ListingBuidlerDeals/ListingBuilderDeals.t3';
import ListingSold from '../Components/ListingSold/ListingSold.t3';
import NavbarT3 from '../Components/navbar/navbar.t3';
import Section2 from '../Components/Section2/section2.t3';
import FooterT3 from '../footer/footer.t3';
import LiveEdithTextHighLighter from '../../../liveEditHighlighterstyles/liveEdithTextHighLighter.component';
import useContactUs from '../../../utils/apis/Contactus.api';

interface Seolisting {
  _id: string;
  title: string;
  keywords: string;
  description: string;
  url: string;
}


export default function Template3Home({ templateData }) {
  const [data, setData] = useState(null);
  const [Seo, setSeo] = useState<Seolisting[]>([]);
  const [seoHomeData, setSeoHomeData] = useState<Seolisting | null>(null);
  const { preview } = useParams();
  const { setTheme } = useMessageContext();
  const [profile, setProfile] = useState(null)
  const token = Cookies.get("token");
  const { stateData, handleSubscriptionForNewsletter, handleState } = useAddUserForNewseletter();

  const { SubmitFormSellerLead, handleFormData, formData } = useContactUs();

  useEffect(() => {
    const href = window.location.href.split('/')[2];
    document.title = href;
    const favicon = `
      <svg
        viewBox="502.6906433105469 56.1640510559082 400.9000549316406 401.4000244140625"
        width="400.9000549316406"
        height="401.4000244140625"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="st1"
          d="M900.4,258.2c-0.3-18.4-3.1-36.2-8-53.1c-1.8-6.2-3.9-12.3-6.3-18.3c-4.9-12.1-10.9-23.7-18-34.5&#10;&#9;c-3.2-4.9-6.6-9.7-10.2-14.3c-9.9-12.6-21.2-24-33.8-34c-4.3-3.4-8.7-6.7-13.3-9.7C779.1,73.1,740.9,60.8,700,60.8&#10;&#9;c-36.2,0-70.2,9.7-99.6,26.6c-4.8,2.8-9.5,5.7-14.1,8.9c-12.9,8.9-24.7,19.3-35.2,30.9c-4.1,4.5-7.9,9.2-11.5,14&#10;&#9;c-10.1,13.4-18.4,28.1-24.9,43.7c-2.5,6-4.7,12.1-6.6,18.4c-5.1,16.8-7.9,34.6-8.4,52.9c0,1.7-0.1,3.4-0.1,5.1&#10;&#9;c0,6.1,0.3,12.2,0.8,18.1c2,22.3,7.8,43.6,16.5,63.3c4.5,10.2,9.9,20,16,29.2c35,52.7,94.1,87.8,161.5,89.7c0,0.3,0,0.5,0,0.6&#10;&#9;l4.9-0.4c0.2,0,0.4,0,0.7,0c66.2,0,125.1-32.3,161.6-82c6.4-8.7,12.1-18,17-27.6c11.1-21.7,18.4-45.6,20.9-70.9c0.7-6.6,1-13.3,1-20&#10;&#9;C900.5,260.2,900.4,259.2,900.4,258.2L900.4,258.2z M661.5,81.3c1.5-0.3,3-0.6,4.5-0.9c-6.3,11.1-14.9,27.4-23.5,47.4&#10;&#9;c-6-2.9-11.8-6.1-16.8-9.7c19.3-22.7,35.5-36.4,35.9-36.7L661.5,81.3z M621.5,189.3c-12.1-5-23.1-11.1-32.8-18&#10;&#9;c8.3-15.1,17.7-28.7,26.9-40.6c6.3,4.6,13.3,8.7,20.8,12.3C631,157.2,625.8,172.8,621.5,189.3L621.5,189.3z M688,221.3&#10;&#9;c-0.2,10.9-0.5,22.1-0.7,33.6c0,3.4-0.1,6.8-0.1,10.2c-20.9-1-40.9-4.1-59.6-8.9c0.8-15.4,2.9-30.6,5.9-45.1&#10;&#9;C650.4,216.4,668.8,219.9,688,221.3L688,221.3z M617.8,205.4c-3.1,14.9-5.4,30.3-6.4,46.2c-16.5-5.4-31.8-12.3-45.4-20.3&#10;&#9;c3.2-15.9,8.7-31.1,15.3-45.3C592.2,193.5,604.4,200,617.8,205.4L617.8,205.4z M610.9,268.5c0,18,1.4,35.2,4,51.6&#10;&#9;c-16.9-4.4-32.9-10.1-47.7-16.9c-3.2-13.5-4.9-27.5-4.7-42c0.1-4.3,0.4-8.6,0.8-12.8C577.8,256.3,593.7,263.2,610.9,268.5&#10;&#9;L610.9,268.5z M618.2,337.7c4.1,19.5,9.6,37.1,15.4,52.7c-10.3-2-20.4-4.4-30.1-7.2c-11.5-17.1-22.7-37.4-30.4-59.9&#10;&#9;C587.2,329.1,602.3,333.9,618.2,337.7L618.2,337.7z M632.4,324.1c-3-16.1-4.9-33.3-5.1-51.1c18.9,4.7,39,7.6,59.8,8.5&#10;&#9;c0,16.7,0.2,33.3,0.6,49.1C668.6,329.9,650.1,327.7,632.4,324.1L632.4,324.1z M688.2,347.1c0.6,18,1.3,34.8,2,49.7&#10;&#9;c-12.9-0.5-25.4-1.6-37.7-3.3c-6-15-11.9-32.6-16.5-52C652.8,344.6,670.3,346.5,688.2,347.1L688.2,347.1z M688.5,204.9&#10;&#9;c-18.2-1.4-35.5-4.7-51.3-9.8c4.2-16.3,9.3-31.8,14.7-45.8c11.8,4.1,24.6,6.9,38.2,8.2C689.5,172,688.9,188,688.5,204.9L688.5,204.9&#10;&#9;z M626.1,92.8c-4,4.3-8.3,9-12.8,14.2c-1.6-1.8-3.4-3.5-4.8-5.4C614.1,98.4,620.1,95.5,626.1,92.8L626.1,92.8z M594.8,110.4&#10;&#9;c2.4,3.2,5.2,6.4,8.2,9.4c-9.4,12-18.8,25.7-27.3,41c-6.2-5.7-11.6-11.8-16-18.2C569.8,130.4,581.7,119.5,594.8,110.4L594.8,110.4z&#10;&#9; M549.2,156c5.3,7,11.6,13.5,18.6,19.6c-7,14.4-12.8,29.8-16.7,46.1c-9.2-6.7-17.5-13.9-24.6-21.7&#10;&#9;C532.1,184.2,539.7,169.5,549.2,156L549.2,156z M516.3,271.8c-0.2-3.5-0.4-7-0.4-10.6c0-15,1.9-29.6,5.3-43.6&#10;&#9;c7.9,7.7,16.9,14.8,26.7,21.3c-1,7.2-1.7,14.5-1.8,22c-0.2,11.2,0.7,22.1,2.5,32.8C536.8,287.1,526,279.8,516.3,271.8L516.3,271.8z&#10;&#9; M544.7,359.8c-12.5-19.7-21.4-41.9-25.7-65.7c10.4,7.4,21.8,14.1,34,20.2c6,22.3,15.4,42.8,25.7,60.7&#10;&#9;C566.8,370.6,555.4,365.5,544.7,359.8L544.7,359.8z M566.7,387.9c8.4,3.4,17.1,6.4,26,9.2c7,10,13.9,18.8,20.2,26.2&#10;&#9;C595.7,413.9,580.1,402,566.7,387.9L566.7,387.9z M650.1,438.3c-2.1-1.9-15.6-14.4-31.4-34.3c7.2,1.6,14.5,3.1,22,4.3&#10;&#9;c5.5,13,10.8,23.6,15.1,31.5C653.9,439.4,652,438.8,650.1,438.3L650.1,438.3z M677,443.8c-2.9-4.7-9.4-16.2-17-32.7&#10;&#9;c10.2,1.2,20.6,2,31.2,2.3c0.7,12.8,1.4,23.5,2,31.7C687.7,444.9,682.3,444.4,677,443.8L677,443.8z M690.7,141&#10;&#9;c-11.6-1.2-22.5-3.6-32.7-6.9c11.7-27.4,23.5-47.8,28.8-56.4c2.3-0.2,4.7-0.2,7-0.3C693.2,89.2,692,111.7,690.7,141L690.7,141z&#10;&#9; M874,201.4c-6.3,6.7-13.5,13-21.5,18.9c-3.3-13.5-7.9-26.4-13.5-38.6c6.6-5,12.7-10.4,18.1-16.1C864,176.8,869.7,188.8,874,201.4&#10;&#9;L874,201.4z M782.6,193.2c-4.1-16.4-9-31.9-14.3-46.1c8.6-3.3,16.4-7.4,23.6-11.9c9.1,12.2,18.2,26.1,26.1,41.2&#10;&#9;C807.5,183.1,795.6,188.7,782.6,193.2L782.6,193.2z M825.1,191.2c5.4,12.3,9.8,25.4,12.7,38.9c-13.8,8.3-29.2,15.4-46,21&#10;&#9;c-0.9-14.3-2.9-28.3-5.6-41.8C800.3,204.5,813.4,198.3,825.1,191.2L825.1,191.2z M785.1,337.2c16.3-3.9,31.7-9,46.3-15&#10;&#9;c-8.1,23.9-20.1,45.3-32.2,63.1c-9.7,2.5-19.8,4.7-30,6.4C775.1,375.7,780.8,357.5,785.1,337.2L785.1,337.2z M788.3,319.7&#10;&#9;c2.6-16.3,4.1-33.7,4-51.6c17.4-5.5,33.6-12.5,48.2-20.8c0.5,4.6,0.8,9.2,0.9,13.9c0.2,14.1-1.5,27.9-4.5,41&#10;&#9;C822,309.2,805.6,315.1,788.3,319.7L788.3,319.7z M814.2,117.1c12.6,10,24,21.7,33.6,34.7c-4.7,5.3-10.1,10.4-16,15.1&#10;&#9;c-8-15.3-17.2-29.2-26.3-41.4C808.5,122.8,811.5,120,814.2,117.1L814.2,117.1z M801,107.5c-1.7,1.8-3.7,3.5-5.6,5.2&#10;&#9;c-5-6.1-9.8-11.6-14.4-16.6C787.9,99.5,794.6,103.3,801,107.5L801,107.5z M743.5,82.5c4.4,3.8,20.5,18.3,38.4,40&#10;&#9;c-6,3.6-12.5,6.8-19.5,9.5c-8.9-21.4-18.1-39-24.8-50.9C739.5,81.6,741.5,82,743.5,82.5L743.5,82.5z M710.4,77.6&#10;&#9;c2,0.1,4.1,0.2,6.2,0.4c5.5,9,17.8,30.4,29.8,59c-12.2,3.1-25.3,4.8-39.2,4.8h0C708.4,111.9,709.7,89.1,710.4,77.6L710.4,77.6z&#10;&#9; M706.5,158.2c0.2,0,0.5,0,0.7,0c16,0,31.2-2.2,45.3-5.9c5.3,14.1,10.3,29.5,14.3,45.8c-18.4,4.8-38.5,7.5-59.6,7.5&#10;&#9;c-0.8,0-1.5,0-2.3,0C705.4,188.8,705.9,172.8,706.5,158.2L706.5,158.2z M703.8,255.1c0.2-11.3,0.4-22.3,0.7-33.1&#10;&#9;c0.9,0,1.8,0.1,2.7,0.1c22.2,0,43.5-2.9,63.1-8c2.7,13.5,4.6,27.5,5.3,41.8c-22.3,5.9-46.6,9.2-71.9,9.4&#10;&#9;C703.7,261.9,703.7,258.5,703.8,255.1L703.8,255.1z M703.6,281.8c25.3-0.2,49.7-3.4,72.3-9.1c-0.2,17.8-2.1,35-5.1,51.1&#10;&#9;c-21.1,4.3-43.5,6.8-66.7,7C703.8,315,703.6,298.5,703.6,281.8L703.6,281.8z M704.7,347.2c21.6-0.2,42.5-2.4,62.5-6.1&#10;&#9;c-4.7,20-10.8,38.1-16.9,53.4c-14.2,1.7-28.7,2.6-43.5,2.7C706,382.2,705.2,365.3,704.7,347.2L704.7,347.2z M726.6,443.1&#10;&#9;c-5.6,0.8-11.2,1.4-16.9,1.7c-0.6-7.9-1.3-18.5-2-31.1c11.9-0.1,23.7-0.7,35.1-1.9C735.8,427.2,729.5,438.2,726.6,443.1L726.6,443.1&#10;&#9;z M755.9,436.4c-2.6,0.8-5.2,1.6-7.8,2.2c4-7.5,8.9-17.4,14-29.2c7.4-1.1,14.8-2.3,21.9-3.8C771.4,421.3,760.5,432.1,755.9,436.4&#10;&#9;L755.9,436.4z M795,418.5c4.7-5.8,9.7-12.2,14.7-19.3c6-1.7,12-3.5,17.8-5.5C817.7,403.1,806.8,411.4,795,418.5L795,418.5z&#10;&#9; M850.4,367.1c-8.5,3.9-17.5,7.4-26.7,10.6c11.2-18.9,21.4-40.8,27.6-64.7c10.4-5.3,20.3-10.9,29.3-17.2&#10;&#9;C875.8,321.9,865.2,346.1,850.4,367.1L850.4,367.1z M883.6,273.5c-8.5,6.8-17.8,13.1-27.9,19c1.6-10.2,2.4-20.8,2.2-31.6&#10;&#9;c-0.1-7.9-0.8-15.6-2-23.2c8.4-5.7,16.2-11.9,23.2-18.6c3.2,13.5,4.9,27.6,4.9,42.1C884,265.4,883.8,269.5,883.6,273.5L883.6,273.5z&#10;&#9; M883.6,273.5"
          style="fill: rgb(204, 204, 204); opacity: 1;"
          transform="matrix(1, 0, 0, 1, 3.0906386375427246, -4.635957717895508)"
        />
      </svg>
    `;
    const svgBase64 = btoa(favicon);

    const Icon = document.getElementById('favicon') as HTMLLinkElement;

    Icon.href = `data:image/svg+xml;base64,${svgBase64}`;
  }, []);

  //local Data
  useEffect(() => {
    const getData = async () => {
      if (!templateData) {
        const data = await GetTemplateData(preview, 3, 1);
        if (data) {
          setData(data);
          setTheme({
            primary_color: data.styles[0].css.primary,
            secondary_color: data.styles[0].css.secondary,
            borderRadius: '16px',
            warning_text: {
              fontFamily: 'Oswald',
              fontSize: '20px',
              fontWeight: '400',
              lineHeight: '23.4px',
            },
            warning_message: {
              fontFamily: 'Roboto',
              fontSize: '18px',
              fontWeight: '400',
              lineHeight: '22.32px',
              textAlign: 'center',
            },
            button: {
              fontFamily: 'Roboto',
              fontSize: '18px',
              fontWeight: '400',
              lineHeight: '23.4px',
            },
          });
        }
      } else {
        setData(templateData);
      }
    };
    getData();
  }, [templateData]);
  useEffect(() => {
    const fetchProfile = async (): Promise<void> => {
      const agentUrl = window.location.href.split("/")[2];
      let config = {
        headers: {},
        params: {},
      };
      if (token) {
        config.headers["x-access-token"] = token;
      } else {
        config.params["domain"] = agentUrl;
      }
      try {
        const profileData = await axios.get("/api/get-agent-profile", config);
        setProfile(profileData.data.data);

      } catch (e) {
        throw new Error(e);
      }
    };
    fetchProfile();
  }, []);


  useEffect(() => {
    const FetchSeo = async () => {
      const token = Cookies.get("token");
      const agentUrl = window.location.href.split("/")[2];
      let config = {
        headers: {},
        params: {},
      };

      if (token) {
        config.headers["x-access-token"] = token;
      } else {
        config.params["domain"] = agentUrl;
      }

      try {
        const fetchData = await axios.get("/api/get-all-seo-entries", config);
        const fetchedData = fetchData.data.data;
        const homeSeoEntry = fetchedData.find((entry) => entry.url.includes('home'));
        setSeoHomeData(homeSeoEntry || null);
      } catch (e) {
        console.error("Error fetching seo listings:", e);
      }
    };

    FetchSeo();
  }, []);
  const defaultDescription = `Detailed REALTOR® profile for ${profile?.name || 'Agent'} , real estate agent at ROYAL STAR REALTY INC. in BRAMPTON, Ontario.`;
  const defaultKeywords = "real estate listings, homes for sale, homes for rent, property listings";


  if (!data)
    return (
      <div id='loadingScreen' className='loading-screen'>
        <div className='loader'></div>
      </div>
    );
  const theme = {
    colors: {
      // primary: data.styles[0].css.primary,
      primary: data.styles[0].css.primary,
      text: data.styles[0]?.css?.secondary,
      //common
      TextGrey: '#6E6E73',
      white: '#FDFDFE',
      InactiveGrey: '#b2b2b2',
      text2: '#000000',
      background: '#f8f9fa',
    },
  };
  // background: #2C3647CC;

  // console.log(transparentize(0.2, theme.colors.primary));
  return (
    <>
      <HelmetSEO seoHomeData={seoHomeData} profile={profile} defaultDescription={defaultDescription} defaultKeywords={defaultKeywords} />
      <ThemeProvider theme={theme}>
        <NavbarT3 data={data.header} />
        {data.sec1.visible && <HeroSection data={data.sec1} />}
        {data.sec3.visible && <FindProperty Data={data.sec3} />}
        <ExclusiveListingTemp1 data={data} />
        <ImageRedirectContainer data-aos='fade-up' />
        <FeaturePropertySlider />
        <Listing1
          title={'Newly added homes'}
          type={'Sale'}
          redirect={'../idxlisting'}
        // subHeading={'Check out some of our exclusive listings'}
        />
        <ListingSold />
        <ListingBuilderDeals />
        <Listing1
          title={'Rental Homes'}
          redirect={'../idxlisting?&sale_or_lease=Lease'}
          type={'Lease'}
        // subHeading={'Check out some of our Rental Homes'}
        />
        {/*<Reveal>
          <Listing property_type="idx" />
        </Reveal>*/}
        {/* <Reveal>
          <Listing property_type='sold' />
        </Reveal>
        <Reveal>
          <Listing property_type='builder_deals' />
        </Reveal> */}
        {/*  <Reveal>
          <Listing property_type="recently_added" />
        </Reveal> */}
        {/* <Listing1
          title={'Recently Added Homes'}
          redirect={'../idxlisting'}
        // subHeading={'Check out some of our latest additions'}
        /> */}
        {/* <ListingSold /> */}
        {/* <ListingBuilderDeals /> */}
        <BlogSlider data-aos='fade-up' />
        {data.sec10.visible && (
          <CitiesCard data={data.sec10} data-aos='fade-up' />
        )}
        {data.sec2.visible && <Section2 data={data.sec2} data-aos='fade-up' />}
        {/* {data.sec11.visible && <NewsLetter data={data.sec11} />} */}

        {/* {data.sec11.visible && ( */}
        {/*   <SubscribeContainer3 */}
        {/*     className='mt-4' */}
        {/*     id='sec5' */}
        {/*     style={{ backgroundImage: `url(/public/${data?.sec11.image})` }} */}
        {/*   > */}
        {/*     <form */}
        {/*       onSubmit={(e) => handleSubscriptionForNewsletter(e)} */}
        {/*       className='container' */}
        {/*     > */}
        {/*       <div className='row pt-0'> */}
        {/*         <div className='col-md-10 mx-auto'> */}
        {/*           <div className='row py-4'> */}
        {/*             <div className='col-12 form-group text-center mb-5'> */}
        {/*               <h1>{data.sec11.text}</h1> */}
        {/*               <p>{data.sec11.description}</p> */}
        {/*             </div> */}
        {/*             <div className='col-md-6 mt-3'> */}
        {/*               <div className='form-group'> */}
        {/*                 <label className='form-label'>Name</label> */}
        {/*                 <input */}
        {/*                   type='text' */}
        {/*                   id='material-input' */}
        {/*                   className='material-input' */}
        {/*                   required */}
        {/*                   onChange={(e) => handleState('name', e.target.value)} */}
        {/*                   value={stateData.name} */}
        {/*                 /> */}
        {/*               </div> */}
        {/*             </div> */}
        {/*             <div className='col-md-6 mt-3'> */}
        {/*               <div className='form-group'> */}
        {/*                 <label className='form-label'>Email</label> */}
        {/*                 <input */}
        {/*                   type='email' */}
        {/*                   id='material-input' */}
        {/*                   className='material-input' */}
        {/*                   required */}
        {/*                   onChange={(e) => handleState('newsletteremail', e.target.value)} */}
        {/*                   value={stateData.newsletteremail} */}
        {/*                 /> */}
        {/*               </div> */}
        {/*             </div> */}
        {/*             <div className='col-12 mt-3'> */}
        {/*               <div className='form-group text-center mb-0'> */}
        {/*                 <button type='submit' className='btn btn-outline-light'> */}
        {/*                   Subscribe */}
        {/*                 </button> */}
        {/*               </div> */}
        {/*             </div> */}
        {/*           </div> */}
        {/*         </div> */}
        {/*       </div> */}
        {/*     </form> */}
        {/*   </SubscribeContainer3> */}
        {/* )} */}
        {data.sec11.visible && (
          <SubscribeContainer3 id="sec5" style={{ backgroundImage: `url(/public/${data?.sec11.image})` }}>
            <form
              onSubmit={(e) => SubmitFormSellerLead(e)}
              className='container'
            >
              <div className='row'>
                <div className='col-md-10 mx-auto'>
                  <div className='row py-4'>
                    <div className='col-12 form-group text-center mb-5'>
                      <LiveEdithTextHighLighter section='sec11' type='text'>
                        <h1>{data.sec11.text}</h1>
                      </LiveEdithTextHighLighter>
                      <LiveEdithTextHighLighter section='sec11' type='description'>
                        <p>{data.sec11.description}</p>
                      </LiveEdithTextHighLighter>
                    </div>
                    <div className='col-md-6 mt-3'>
                      <div className='form-group'>
                        <label className='form-label'>Name</label>
                        <input
                          type='text'
                          id='material-input'
                          className='material-input'
                          required
                          onChange={(e) => handleFormData('name', e.target.value)}
                          value={formData.name}
                        />
                      </div>
                      <div className='form-group'>
                        <label className='form-label'>Phone</label>
                        <input
                          type='phone'
                          id='material-input'
                          className='material-input'
                          required
                          onChange={(e) => handleFormData('phone', e.target.value)}
                          value={formData.phone}
                        />
                      </div>
                    </div>
                    <div className='col-md-6 mt-3'>
                      <div className='form-group'>
                        <label className='form-label'>Email</label>
                        <input
                          type='email'
                          id='material-input'
                          className='material-input'
                          required
                          onChange={(e) =>
                            handleFormData('email', e.target.value)
                          }
                          value={formData.email}
                        />
                      </div>
                      <div className='form-group'>
                        <label className='form-label'>Message</label>
                        <input
                          type='text'
                          id='material-input'
                          className='material-input'
                          required
                          onChange={(e) =>
                            handleFormData('message', e.target.value)
                          }
                          value={formData.message}
                        />
                      </div>
                    </div>
                    <div className='col-12 mt-3'>
                      <div className='form-group text-center mb-0'>
                        <button type='submit' className='btn btn-outline-light'>
                          Contact us
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </SubscribeContainer3>
        )}
        <FooterT3 data={data} />
      </ThemeProvider>
    </>
  );
}
